import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import DivisionDetail from "@/pages/DivisionDetail";
import Book from "@/pages/Book";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminListings from "@/pages/AdminListings";
import AdminSettings from "@/pages/AdminSettings";

const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("config", "G-V1J946V0JM", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
  return null;
};

const Chrome = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <Chrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/divisions/:slug" element={<DivisionDetail />} />
            <Route path="/book" element={<Book />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/listings" element={<AdminListings />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
          </Routes>
        </Chrome>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              borderRadius: "12px",
              border: "1px solid #E2E8F0",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
